import React from 'react';
import heroVideo from "../../assests/cfivideo.mp4";

function Hero() {
  return (
    <section
      className="hero"
      id="home"
      style={{
        width: "100%",
        height: "600px",
        margin: 0,
        padding: 0,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <video
        src={heroVideo}
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />

      {/* Dark Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.15)",
          zIndex: 1,
        }}
      ></div>

      {/* Hero Text */}
      <div
        className="hero-donation-content"
        style={{
          position: "absolute",
          left: "18%",
          bottom: "70px",
          zIndex: 2,
          color: "#fff",
        }}
      >
        <h1
          style={{
            margin: "0 0 15px 0",
            padding: 0,
            color: "#fff",
            fontFamily: "Arial, sans-serif",
            fontSize: "34px",
            lineHeight: "1.2",
            fontWeight: "400",
          }}
        >
          Let's Make a Difference Today!
        </h1>

        <button
          type="button"
          onClick={() =>
            window.open(
              "https://www.paypal.com/donate/?hosted_button_id=Y4YKUWQE3UWWY",
              "_blank",
              "noopener,noreferrer"
            )
          }
          style={{
            background: "#f58232",
            color: "#fff",
            border: "none",
            padding: "14px 25px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            fontFamily: "Arial, sans-serif",
          }}
        >
          MAKE A DONATION
        </button>
      </div>
    </section>
  );
}

export default Hero;
